module.exports = __webpack_public_path__ + "img/twitter.3afe0682.svg";